import React, { Component, Fragment } from 'react';
import queryString from 'query-string';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as BenefitsTypesActions, Selectors as BenefitsTypesSelectors } from 'store/ducks/benefitsTypes';

import { Access } from 'common';
import { Page, Panel, Loading, Breadcrumbs, Pagination } from 'components';

class List extends Component {
  state = {
    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Benefícios', to: '/benefits' },
      { name: 'Lista de Tipos de Benefícios', to: '' },
    ],
  };

  componentDidMount() {
    const { location, getBenefitsTypesRequest } = this.props;
    const params = queryString.parse(location.search);
    const page = params.page ? params.page : 1;

    getBenefitsTypesRequest(page);
  }

  componentDidUpdate(oldProps) {
    const { location, getBenefitsTypesRequest } = this.props;
    if (queryString.parse(oldProps.location.search).page !== queryString.parse(location.search).page) {
      getBenefitsTypesRequest(queryString.parse(location.search).page);
    }
  }

  render() {
    const { breadcrumbs } = this.state;
    const { benefitsTypes } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Page.Title>Lista de Tipos de Benefícios</Page.Title>

        <Panel className="panel-list">
          {Access.hasPermissions("edit-benefits") && (
            <Link
              to="/benefits/types/create"
              className="button-add margin-bottom-20"
            >
              Adicionar Tipo de Benefício
            </Link>
          )}

          {!benefitsTypes.data.length && benefitsTypes.loading ? (
            <Loading type="page" size="x-large" />
          ) : (
            <Fragment>
              {benefitsTypes.loading && <Loading type="table" size="x-large" />}

              <table className="contact-table table table-curved table-striped">
                <thead>
                  <tr>
                    <th>título</th>
                    <th>descrição</th>
                    <th>ativo</th>
                    <th>ativação automatica</th>
                    <th className="text-right">ação</th>
                  </tr>
                </thead>

                <tbody>
                  {!benefitsTypes.data.length && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        Nenhum registro encontrado.
                      </td>
                    </tr>
                  )}

                  {benefitsTypes.data.map(benefitType => (
                    <tr key={String(benefitType.id)}>
                      <td>{benefitType.attributes.title}</td>
                      <td>{benefitType.attributes.description}</td>
                      <td>{benefitType.attributes.active ? "Sim" : "Não"}</td>
                      <td>
                        {benefitType.attributes.automatically_activated
                          ? "Sim"
                          : "Não"}
                      </td>
                      <td className="text-right">
                        {Access.hasPermissions("edit-benefits") && (
                          <Link
                            to={`/benefits/types/${benefitType.id}/edit`}
                            className="button-icon"
                          >
                            <span className="glyph glyph-eye" />
                          </Link>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>

                <tfoot>
                  <tr>
                    <th colSpan="6" />
                  </tr>
                </tfoot>
              </table>

              <Pagination
                className="m-t-20"
                current={benefitsTypes.page}
                total={benefitsTypes.totals}
                {...this.props}
              />

              {Access.hasPermissions("edit-benefits") && (
                <Link to="/benefits/types/create" className="button-add">
                  Adicionar Tipo de Benefício
                </Link>
              )}
            </Fragment>
          )}
        </Panel>
      </Page>
    );
  }
}

const mapState = state => ({
  benefitsTypes: {
    ...state.benefitsTypes,
    data: BenefitsTypesSelectors.benefitsTypes(state.benefitsTypes.data),
  },
});

const mapActions = dispatch => bindActionCreators(BenefitsTypesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(List);
